import keys from 'lodash-es/keys';
import {Filters} from '@common/types/components/datatable.types';

export const initializePaginationFilters = (filters: Filters, initPaginationFilters: Filters, key: string): Filters => ({
  ...filters,
  ...(!keys(initPaginationFilters).includes(key) && initPaginationFilters)
});
